var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"small":_vm.small,"light":_vm.light,"type":"button"},on:{"click":_vm.onexport}},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":_vm.small}},[_vm._v(" mdi-microsoft-excel")]),_vm._v("Excel\n  ")],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-004d18b0","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/artworks/Excel.vue
// module id = OUKN
// module chunks = 1